import React from 'react';

import AccordionItem from '../../shared/components/accordion/accordion-item/accordion-item';
import SecondaryNav from '../../shared/components/secondary-nav/secondary-nav';
import ShLink from '../../shared/components/sh-link/sh-link';
import SocialMediaButtons from '../../shared/components/social-media-buttons/social-media-buttons';
import { Media } from '../../shared/contexts/media/MediaContext';
import { NavColumn } from '../../shared/hooks/column-end/useColumnEnd';
import { GlobalFooterContent, IconPack, SecondaryNavContent } from '../../shared/models/app-data-model';
import './global-footer-mobile.scss';

export type GlobalFooterMobileProps = {
  content: GlobalFooterContent;
  iconPack: IconPack[];
};

const GlobalFooterMobile: React.FC<GlobalFooterMobileProps> = ({ content, iconPack }: GlobalFooterMobileProps) => {
  return (
    <Media lessThan="desktop">
      <div className="global-footer-mobile">
        <div className="accordion-container">
          {content?.footer_nav?.map((item, index) => {
            const itemWithChildren = item.primary_nav_item?.reference.find((el) => el.footer_nav);
            const itemWithLink = item.primary_nav_item?.reference.find((el) => el.url || el.link);

            if (itemWithChildren) {
              const itemData: NavColumn = {
                index: index,
                content: itemWithChildren.footer_nav as SecondaryNavContent[]
              };

              return (
                <AccordionItem
                  iconPack={iconPack}
                  heading={item.primary_nav_item.title}
                  headingClass={'primary-nav-item'}
                  open={index === 0}
                  defaultIcon={true}
                  key={index}
                >
                  <SecondaryNav columns={[itemData]} />
                </AccordionItem>
              );
            } else if (itemWithLink) {
              return (
                <ShLink
                  title={item.primary_nav_item.title}
                  className="primary-nav-item primary-nav-item-link"
                  key={index}
                  reference={item.primary_nav_item.reference}
                />
              );
            }
          })}
        </div>

        <div className="global-footer-mobile-social-media">
          <SocialMediaButtons socials={content.social_media_links} className="primary-nav-item" />
        </div>
      </div>
    </Media>
  );
};

export default GlobalFooterMobile;
